import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { shouldShowToast } from "./apiError.util";

let suppressErrors = false;

export const beginSessionExpiry = () => {
	suppressErrors = true;
};

export const resumeErrorToasts = () => {
	suppressErrors = false;
};

export const successToastify = (msg) => {
	Toastify({
		text: msg,
		newWindow: true,
		close: true,
		gravity: "top", // `top` or `bottom`
		position: "right", // `left`, `center` or `right`
		stopOnFocus: true, // Prevents dismissing of toast on hover
		style: {
			background: "#55eb34",
		},
	}).showToast();
};

export const errorToastify = (msg, options = {}) => {
	if (!msg) return;
	if (suppressErrors && options.id !== "session-expired") return;
	if (!shouldShowToast(options.id || msg)) return;
	Toastify({
		text: msg,
		newWindow: true,
		close: true,
		gravity: "top", // `top` or `bottom`
		position: "right", // `left`, `center` or `right`
		stopOnFocus: true, // Prevents dismissing of toast on hover
		style: {
			background: "#ff2400",
		},
	}).showToast();
};
